import { Colour_Tournament } from "./Utils";

export class Attendance {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
    state,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Attendance";
    this.scene = "VoiceOf";
    this.data = [];
    this.page = 7011;
    this.state = state;
  }

  async preview({ options }) {
    this.onAir = false;
    if (options.push_up) {
      this.page = 7015;
    } else {
      this.page = 7011;
    }
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      try {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      } catch (err) {}
      // }
      if (options.push_up) {
        xml.payload.field.find((item) => {
          return item.attr.name === "103";
        }).value = "Attendance";
        xml.payload.field.find((item) => {
          return item.attr.name === "200";
        }).value =
          options.value;
      } else {
         xml.payload.field.find((item) => {
          return item.attr.name === "102";
        }).value = "Attendance";
        xml.payload.field.find((item) => {
          return item.attr.name === "111";
        }).value =
         options.value;
      }

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
